<template>
<div id="contentWrap">
  <!-- <div  class="banner"></div> -->
  <div v-show="isIndexShowBanner" class="slider_container">
    <div>
      <img src="../../../assets/images/h-banner_01.png" alt="pure css3 slider" />
    </div>
    <div>
      <img src="../../../assets/images/h-banner_02.png" alt="pure css3 slider" />
    </div>
    <div>
      <img src="../../../assets/images/h-banner_03.png" alt="pure css3 slider" />
    </div>
  </div>
  <div class="content left">
    <CustomAside></CustomAside>
    <router-view></router-view>
  </div>
</div>
</template>

<script>
import CustomAside from './Aside';
export default {
  name: 'private',
  components: {
    CustomAside
  },
  data() {
    return {
      isIndexShowBanner: false,
    };
  },
  mounted() {
    if (this.$route.path.substr(0, 11) === '/Main/Index') {
      this.isIndexShowBanner = true;
    }
  },
  watch: {
    $route() {
      if (this.$route.path.substr(0, 11) === '/Main/Index') {
        this.isIndexShowBanner = true;
      } else {
        this.isIndexShowBanner = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Layout.vue?a10f8746